import { useState } from 'react'
import { getImgSrc } from '#app/shared/lib/misc.tsx'
import { FullScreenGallery } from '#app/shared/ui/data-display/carousel/FullScreenGallery.tsx'
import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import { Icon } from '#app/shared/ui/icons/Icon.js'

const certifications = [
  'Kilometraje verificado',
  'Vehiculo sin accidentes previos',
  'Vehiculo sin averías significativas previas',
  'Reacondicionamiento estético y mecánico premium',
  'Revisado y entregado en perfectas condiciones mecánicas',
  'Garantia de hasta 3 años',
]

type Props = {
  signOfUseImageIds: string[]
  car: any
}

export default function VehicleCertificates({ car, signOfUseImageIds }: Props) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <div className={`border border-neutral-75 bg-white`}>
        <div
          className={`
            flex flex-col gap-6

            lg:h-[300px] lg:flex-row lg:items-center lg:gap-[90px] lg:border-b
            lg:border-neutral-75
          `}
        >
          <div
            className={`
              pl-5 pt-5

              lg:pl-[43px]
            `}
          >
            <p
              className={`
                text-h4 text-neutral-900

                lg:text-h3
              `}
            >
              Cada coche, adecuado mecánica y estéticamente para tu total
              satisfacción.
            </p>
            <Spacer size="20px" />
            <div
              className={`
                flex flex-col gap-3 pb-5

                md:grid md:grid-cols-1 md:gap-x-[46px] md:gap-y-3
              `}
            >
              {certifications.map((certification) => (
                <div
                  className={`
                    flex items-center gap-1

                    lg:h-2.5
                  `}
                  key={certification}
                >
                  <Icon
                    name="basic/check"
                    size="12px"
                    className={`text-primary-500`}
                  />
                  <p className={`text-subtitle1-medium text-neutral-900`}>
                    {certification}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div
            className={`
              min-h-[225px] w-full border-y border-neutral-75 bg-[#F8FDFD] px-4
              pb-6 pt-5

              lg:h-full lg:w-[303px] lg:border-y-0 lg:border-l lg:px-4 lg:pb-0
            `}
          >
            <div
              className={`
                w-full gap-[26px] rounded-base pl-3 pr-[22px]

                lg:flex
              `}
            >
              <div className="flex flex-col items-start gap-3 pt-5">
                <img
                  className={`h-[45px] w-[45px]`}
                  src="/img/isotipo.png"
                  alt="shield"
                />
                <p
                  className={`
                    text-subtitle2-semibold tracking-[-1.28px] text-neutral-600
                  `}
                >
                  CONDICIÓN
                </p>

                <p className="text-h3 tracking-[-1.28px] text-primary-600">
                  {car.condition}
                </p>
                <button className={`flex cursor-default`}>
                  <p
                    className={`
                      w-full whitespace-nowrap text-subtitle1-bold
                      text-primary-600
                    `}
                  >
                    Sin marcas de uso
                  </p>
                </button>
                <FullScreenGallery
                  open={open}
                  onClose={() => setOpen(false)}
                  imagesArray={signOfUseImageIds.map((image) =>
                    getImgSrc(image, 'carImage'),
                  )}
                  initialIndex={0}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
